var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pega-comment thread",
      class: [
        { "boss-c": _vm.commentThread.isCompanyStaff },
        { "boss-s": !_vm.commentThread.isCompanyStaff },
        { fixed: _vm.allFixed },
      ],
      attrs: { id: _vm.commentThreadId, "data-test": "comment-thread-top" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
        select: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.isShowDeleteIcon
        ? _c("div", {
            staticClass: "boss-icon-cross delete-icon",
            attrs: { "data-test": "delete-icon" },
            on: { click: _vm.deleteThread },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "comment-accordion",
          class: { "is-open": _vm.isOpen },
          attrs: { "data-test": "comment-accordion" },
        },
        [
          _c(
            "div",
            {
              staticClass: "boss-mini-accordion-head comment-header",
              attrs: { "data-test": "comment-header" },
              on: { click: _vm.toggle },
            },
            [
              _vm._v(
                "\n      「" +
                  _vm._s(_vm.commentThread.targetText) +
                  "」へのコメント\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "boss-mini-accordion-body comment-body" },
            [
              _c("hr", { staticClass: "solid" }),
              _vm._v(" "),
              _vm.isShowAllFixed
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "comment-piece",
                        attrs: { "data-test": "all-fixed-for-boss-s" },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "boss-checkbox",
                            class: { red: _vm.allFixed },
                            attrs: { "data-test": "checkbox-label" },
                          },
                          [
                            _c("input", {
                              staticClass: "boss-input-checkbox",
                              attrs: {
                                type: "checkbox",
                                "data-test": "checkbox",
                              },
                              domProps: { checked: _vm.allFixed },
                              on: { click: _vm.toggleFixedAll },
                            }),
                            _vm._v(
                              _vm._s(_vm._f("fixedText")(_vm.allFixed)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr", {
                      attrs: { "data-test": "all-fixed-for-boss-s-hr" },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.comments, function (comment) {
                return _c(
                  "job-preview-comment",
                  _vm._g(
                    { key: comment.id, attrs: { comment: comment } },
                    _vm.$listeners
                  )
                )
              }),
              _vm._v(" "),
              _vm.isAddingComment
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.addingComment.comment,
                        expression: "addingComment.comment",
                      },
                    ],
                    ref: "addComment",
                    staticClass: "edit-comment",
                    class: { pending: _vm.isPending },
                    attrs: { "data-test": "add-comment" },
                    domProps: { value: _vm.addingComment.comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.addingComment,
                          "comment",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _c("div", { staticClass: "grid-x" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cell medium-2 pega-cursor-pointer",
                        on: { click: _vm.toggle },
                      },
                      [
                        _c("div", {
                          staticClass: "comment-close-button",
                          attrs: { "data-test": "comment-close-button" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell auto" }, [
                      _c(
                        "div",
                        {
                          staticClass: "add-area",
                          attrs: { "data-test": "add-area" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "boss-button add-button",
                              attrs: { "data-test": "add-button" },
                              on: { click: _vm.add },
                            },
                            [
                              _vm._v(
                                "\n              コメントを追加する\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell medium-2" }),
                  ]),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }